import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useExperimentGroup } from 'shared/src/context/UserContext/useExperimentGroup';

export const useRelatedLiveCampaign = () => {
  const goodsSno = useGoodsSno();
  const isTargetGroup = useExperimentGroup({
    sno: 'EXP1558',
    targetGroups: ['B', 'C'],
  });

  return useQuery({
    queryKey: queryKey.relatedLiveCampaign(goodsSno),
    queryFn: () => goodsService.getRelatedLiveCampaign(goodsSno),
    enabled: isTargetGroup,
  });
};
